import './Footer.css';

const Footer = () => {
  const handleHoverMove = (event) => {
    const target = event.target.closest('.hover-glow');
    if (!target) {
      return;
    }
    const rect = target.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    target.style.setProperty('--mx', `${x}px`);
    target.style.setProperty('--my', `${y}px`);
  };

  return (
    <footer className="footer" onMouseMove={handleHoverMove}>
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-brand">
            <div className="footer-brand-mark">
              <div className="line-anim">
                <span className="line-segment line-left" />
                <span className="line-segment line-angle" />
                <span className="line-segment line-right" />
              </div>
            </div>
            <div className="footer-brand-text">
              <div className="footer-brand-name">Z<span className="brand-q">o</span>pe<span className="brand-q">o</span></div>
            </div>
          </div>
          <nav className="footer-navigation" aria-label="Footer navigation">
            <div className="nav-column">
              <h3 className="nav-heading hover-glow" data-text="Product">Product</h3>
              <ul className="nav-list">
                <li><a href="/features" className="nav-link hover-glow" data-text="Features">Features</a></li>
                <li><a href="/pricing" className="nav-link hover-glow" data-text="Pricing">Pricing</a></li>
                <li><a href="/changelog" className="nav-link hover-glow" data-text="Updates">Updates</a></li>
              </ul>
            </div>
            <div className="nav-column">
              <h3 className="nav-heading hover-glow" data-text="Company">Company</h3>
              <ul className="nav-list">
                <li><a href="/about" className="nav-link hover-glow" data-text="About">About</a></li>
                <li><a href="/blog" className="nav-link hover-glow" data-text="Blog">Blog</a></li>
                <li><a href="/careers" className="nav-link hover-glow" data-text="Careers">Careers</a></li>
              </ul>
            </div>
            <div className="nav-column">
              <h3 className="nav-heading hover-glow" data-text="Legal">Legal</h3>
              <ul className="nav-list">
                <li><a href="/privacy" className="nav-link hover-glow" data-text="Privacy">Privacy</a></li>
                <li><a href="/terms" className="nav-link hover-glow" data-text="Terms">Terms</a></li>
                <li><a href="/security" className="nav-link hover-glow" data-text="Security">Security</a></li>
              </ul>
            </div>
          </nav>
        </div>
        <div className="footer-seal">
          <div className="seal-content">
            <small className="seal-text hover-glow" data-text="© 2026 Zopeo">© 2026 Zopeo</small>
            <span className="seal-divider" aria-hidden="true">·</span>
            <small className="seal-text">All rights reserved.</small>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
